<template>
  <v-app>
    <v-container fluid class="dashboard-container pa-0">
      <div class="dashboard-content">
        <v-row no-gutters class="dashboard-grid">
          <v-col cols="12" :class="hasBottomSlots ? 'top-row' : 'full-height-row'">
            <v-row no-gutters class="h-100" style="position: relative;">
              <v-col 
                :cols="hasTopLeft && hasTopRight ? 6 : 12" 
                class="telemetry-section" 
                :class="{ 'add-bottom-border': !hasBottomSlots }"
                v-if="hasTopLeft"
              >
                <slot name="top-left"></slot>
              </v-col>
              <div 
                v-if="hasSingleBottomSlot && hasTopLeft && hasTopRight" 
                class="top-only-vertical-separator"
              ></div>
              <div 
                v-if="hasTopLeft && hasTopRight && !hasSingleBottomSlot" 
                class="vertical-separator"
              ></div>
              <v-col 
                :cols="hasTopLeft && hasTopRight ? 6 : 12" 
                class="telemetry-section" 
                :class="{ 'add-bottom-border': !hasBottomSlots }"
                v-if="hasTopRight"
              >
                <slot name="top-right"></slot>
              </v-col>
            </v-row>
          </v-col>

          <div class="horizontal-separator" v-if="hasBottomSlots"></div>

          <v-col cols="12" class="bottom-row" v-if="hasBottomSlots">
            <v-row no-gutters class="h-100">
              <v-col 
                :cols="hasBottomLeft && hasBottomRight ? 6 : 12" 
                class="telemetry-section" 
                v-if="hasBottomLeft"
              >
                <slot name="bottom-left"></slot>
              </v-col>
              <div class="vertical-separator" v-if="hasBottomLeft && hasBottomRight"></div>
              <v-col 
                :cols="hasBottomLeft && hasBottomRight ? 6 : 12" 
                class="telemetry-section" 
                v-if="hasBottomRight"
              >
                <slot name="bottom-right"></slot>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'DashboardLayout',
  computed: {
    hasTopLeft() {
      return !!this.$slots['top-left']
    },
    hasTopRight() {
      return !!this.$slots['top-right']
    },
    hasBottomLeft() {
      return !!this.$slots['bottom-left']
    },
    hasBottomRight() {
      return !!this.$slots['bottom-right']
    },
    hasBottomSlots() {
      return this.hasBottomLeft || this.hasBottomRight
    },
    hasSingleBottomSlot() {
      return (this.hasBottomLeft && !this.hasBottomRight) || (!this.hasBottomLeft && this.hasBottomRight)
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  user-select: none;
  pointer-events: none;
  cursor: none !important;
  cursor: url('data:,') 0 0, none !important;
}

.dashboard-content {
  height: 100vh;
  overflow: hidden;
}

.dashboard-grid {
  height: 100%;
}

.top-row, .bottom-row {
  height: calc(50% - 1px);
}

.full-height-row {
  height: 100%;
}

.telemetry-section {
  padding: 8px;
  height: 100%;
}

.add-bottom-border {
  border-bottom: 2px solid #000;
}

.horizontal-separator {
  width: 100%;
  height: 2px;
  background-color: #000;
  flex-shrink: 0;
}

.vertical-separator {
  width: 2px;
  height: 100%;
  background-color: #000;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 10;
}

.top-only-vertical-separator {
  width: 2px;
  height: 100%;
  background-color: #000;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 10;
}

.dashboard-container * {
  overflow: hidden !important;
}
</style>
